import { InputGroup, Label, Menu, MenuItem } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import React, { ChangeEventHandler, ReactNode, useMemo, useState } from "react";

import { DrawToolbarStateItem, usePositionSets } from "../hooks";
import styles from "./fast-add-context-menu.module.scss";

export interface FastAddContextMenuProps {
  fastPlace: DrawToolbarStateItem;
  children: ReactNode;
}

export const FastAddContextMenu = ({ children }: FastAddContextMenuProps) => {
  const positionSets = usePositionSets();

  const [search, setSearch] = useState<string>("");

  const handleSearch: ChangeEventHandler<HTMLInputElement> = (event) => {
    setSearch(event.target.value);
  };

  const filteredPositionSets = useMemo(() => {
    const filteredSearch = search.replaceAll("-", "").toLowerCase();
    return filteredSearch.length > 0
      ? positionSets.filter((set) => set.label.replaceAll("-", "").toLowerCase().includes(filteredSearch))
      : positionSets;
  }, [search, positionSets]);

  return (
    <Popover2
      interactionKind="click"
      content={
        <Menu>
          <InputGroup
            autoFocus
            className={styles.searchSetsInput}
            placeholder="Search Sets..."
            onChange={handleSearch}
          />
          <Menu className={styles.setsMenu}>
            {filteredPositionSets.map((set, key) => (
              <MenuItem
                text={
                  <div className={styles.setMenuItem}>
                    <Label className={styles.label}>{set.label}</Label>
                    {set.setThumbnail}
                  </div>
                }
                onClick={() => {
                  setSearch("");
                  set.onClick && set.onClick();
                }}
                key={key}
              />
            ))}
          </Menu>
        </Menu>
      }
    >
      {children}
    </Popover2>
  );
};
